import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react'
import { cardiboxActions, cardiboxSelectors } from 'redux-cardibox'
import { connect } from 'react-redux'
import appConst from '../../../../../constant/appConstants'
import Popup from '../../../../../components/Popup'
import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import ButtonDefault from '../../../../../components/ButtonDefault'
import { FormattedMessage } from 'react-intl'
import { useBreakpoints } from '../../../../../components/breakpoints/BreakpointsProvider'
import RibService from '../../../../../api/gerep/RibService'
import LocalStorage from '../../../../../business/storage/LocalStorage'
import { ToastType } from '../../../../../components/toast/toastConstants'
import UserService from '../../../../../api/gerep/UserService'
import { ToastContext } from '../../../../../components/toast/ToastContext'

type DeleteRibPopinProps = {
	open: boolean
	setOpen: Dispatch<SetStateAction<boolean>>
	setUserConjointAccess: Dispatch<SetStateAction<any>>
}

const ARTICLE_SHORTCUT = 'partage_acces_cancel'

const ConfirmCancelInvitePopin: React.FC<DeleteRibPopinProps> = (
	{
		open,
		setOpen,
		setUserConjointAccess,
		// @ts-ignore
		confirmDelete,
		// @ts-ignore
		getArticleByShortcut
	}
) => {
	const { isMobile, isTabletPortrait } = useBreakpoints()
	const { addToast } = useContext(ToastContext)
	const [loading, setLoading] = useState<boolean>(false)

	useEffect(() => {
		getArticleByShortcut(appConst.cardiboxApi, ARTICLE_SHORTCUT)
	}, [])

	const onConfirm = () => {
		setLoading(true)
		UserService.getUserConjointCancelInvite(LocalStorage.getToken())
			.then(() => {
				setUserConjointAccess(null)
			})
			.catch(() => addToast(ToastType.ERROR, '', 'Echec de la suppression de l\'invitation'))
			.finally(() => {
				setLoading(false)
				setOpen(false)
			})
	}

	return (
		<Popup maxWidth={isTabletPortrait ? '800px' : '600px'} open={open} setOpen={setOpen} title={confirmDelete && confirmDelete.fields.title}>
			<Typography variant="body2" dangerouslySetInnerHTML={{ __html: confirmDelete && confirmDelete.fields.body }} />
			<Box display="flex" justifyContent="center">
				<Stack direction={isTabletPortrait ? 'column' : 'row'} spacing="12px">
					<ButtonDefault variant="outlined" onClick={() => setOpen(false)}>
						<FormattedMessage id="global.button.cancel" />
					</ButtonDefault>
					<ButtonDefault
						fullWidth={isMobile}
						variant="contained"
						onClick={onConfirm}
					>
						{loading ? <CircularProgress size={24} color="inherit" /> : <FormattedMessage id="global.button.delete" />}
					</ButtonDefault>
				</Stack>
			</Box>
		</Popup>
	)
}

const mapStateToProps = (state: any) => ({
	confirmDelete: cardiboxSelectors.articles.getByShortcut(state.cardibox)[ARTICLE_SHORTCUT]
})

export default connect(
	mapStateToProps,
	{
		getArticleByShortcut: cardiboxActions.articles.getByShortcut
	}
)(ConfirmCancelInvitePopin)
